module.exports = __webpack_public_path__ + "static/img/pin-no-spray-active.85875be.svg";